import { Route, Routes } from 'react-router-dom';
import App from './App';
import LogIn from '../auth/LogIn';
import Users from '../users/Users';
import User from '../users/user/User';
import ApiPage from '../api/ApiPage';
import LoginUsersList from '../loginUsers/LoginUsersList';
import { CouponDetails, CouponsList } from '../coupons';
import { EventTypesList, EventTypeDetails } from '../eventTypes';
import { FeatureFlagsList } from '../featureFlags';
import { IncidentDetails, IncidentsList } from '../diagnostics';
import { DIAGNOSTICS_ROUTE, INCIDENT_ROUTE_PATTERN } from '../diagnostics/routes';
import { InsightRecomputePage } from '../insightRecompute';

const AppRoutes = (): JSX.Element => (
  <Routes>
    <Route path="/" element={<App />}>
      <Route path="/users" element={<Users />}>
        <Route path=":userId" element={<User />} />
      </Route>
      <Route path="/login-users" element={<LoginUsersList />} />
      <Route path="/api-page" element={<ApiPage />} />
      <Route path="/coupons" element={<CouponsList />} />
      <Route path="/coupons/:couponId" element={<CouponDetails />} />
      <Route path="/event-types" element={<EventTypesList />} />
      <Route path="/event-types/:eventTypeId" element={<EventTypeDetails />} />
      <Route path="/feature-flags" element={<FeatureFlagsList />} />
      <Route path={DIAGNOSTICS_ROUTE} element={<IncidentsList />} />
      <Route path={INCIDENT_ROUTE_PATTERN} element={<IncidentDetails />} />
      <Route path="/insight-recompute" element={<InsightRecomputePage />} />
    </Route>
    <Route path="/login" element={<LogIn />} />
  </Routes>
);

export default AppRoutes;
